import React, { useEffect, useState } from "react";
import api from "../api";

const AdminAudienceCategoryDetail = () => {
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const [list, setList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({
    event: "",
    audienceCategory: "",
    biayaEvent: 0,
    categoryEvent: ""
  });
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const url = search
      ? `${apiUrl}/api/audience-category-detail/search?page=${page}&size=${size}&q=${encodeURIComponent(search)}`
      : `${apiUrl}/api/audience-category-detail?page=${page}&size=${size}`;
    api.get(url)
      .then(res => {
        setList(res.data.content);
        setTotalPages(res.data.totalPages);
      });
    api.get(`${apiUrl}/api/events?page=0&size=100`)
      .then(res => setEvents(res.data.content));
  }, [apiUrl, page, size, showModal, search]);

  useEffect(() => {
    if (form.event) {
      api.get(`${apiUrl}/api/audience-category/by-event?eventId=${form.event}&page=0&size=100`)
        .then(res => setCategories(res.data.content));
    } else {
      setCategories([]);
    }
  }, [form.event, apiUrl]);

  const openCreate = () => {
    setEditId(null);
    setForm({
      event: "",
      audienceCategory: "",
      biayaEvent: 0,
      categoryEvent: ""
    });
    setShowModal(true);
  };

  const openEdit = (item) => {
    setEditId(item.id);
    setForm({
      event: item.audienceCategory?.event?.id || "",
      audienceCategory: item.audienceCategory?.id || "",
      biayaEvent: item.biayaEvent || 0,
      categoryEvent: item.categoryEvent || ""
    });
    setShowModal(true);
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const data = new FormData();
    data.append("audienceCategory", form.audienceCategory);
    data.append("biayaEvent", form.biayaEvent);
    data.append("categoryEvent", form.categoryEvent);
    try {
      if (editId) {
        await api.put(`${apiUrl}/api/audience-category-detail/${editId}`, data);
      } else {
        await api.post(`${apiUrl}/api/audience-category-detail`, data);
      }
      setShowModal(false);
    } catch {
      alert("Gagal simpan data");
    }
  };

  const handleDelete = async id => {
    if (!window.confirm("Yakin hapus data ini?")) return;
    try {
      await api.delete(`${apiUrl}/api/audience-category-detail/${id}`);
      setList(list.filter(x => x.id !== id));
    } catch {
      alert("Gagal hapus data");
    }
  };

  const setPageListItems = (event) => {
    const value = parseInt(event.target.getAttribute('data-value'), 10);
    setSize(value);
    setPage(0);
  };

  return (
    <div className="page-wrapper">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Detail Kategori Peserta</h2>
            </div>
            <div className="col-md-auto col-sm-12">
              <div className="input-group input-group-flat w-auto">
                <input
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  placeholder="Cari Kategori"
                  value={search}
                  onChange={e => { setSearch(e.target.value); setPage(0); }}
                />
              </div>
            </div>
            <div className="col-auto ms-auto d-print-none">
              <button className="btn btn-primary" onClick={openCreate}>
                Buat Detail Kategori
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="card">
            <div className="table-responsive">
              <table className="table card-table table-vcenter text-nowrap datatable table-hover">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Event</th>
                    <th>Kategori Peserta</th>
                    <th>Biaya Event</th>
                    <th>Kategori Event</th>
                    <th>Dibuat</th>
                    <th>Diupdate</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {list.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center">Data tidak ditemukan</td>
                    </tr>
                  ) : list.map((item, idx) => (
                    <tr key={item.id}>
                      <td>{page * size + idx + 1}</td>
                      <td>{item.audienceCategory?.event?.eventCode} - {item.audienceCategory?.event?.title}</td>
                      <td>{item.audienceCategory?.namaCategory}</td>
                      <td>{item.biayaEvent && Number(item.biayaEvent).toLocaleString("id-ID", { style: "currency", currency: "IDR" })}</td>
                      <td>{item.categoryEvent}</td>
                      <td>{item.cdate ? new Date(item.cdate).toLocaleString("id-ID") : '-'}</td>
                      <td>{item.udate ? new Date(item.udate).toLocaleString("id-ID") : '-'}</td>
                      <td>
                        <button className="btn btn-sm btn-warning me-1" onClick={() => openEdit(item)}>Edit</button>
                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="card-footer d-flex align-items-center">
              <div className="dropdown">
                <a className="btn dropdown-toggle" data-bs-toggle="dropdown">
                  <span id="page-count" className="me-1">{size}</span>
                  <span>records</span>
                </a>
                <div className="dropdown-menu">
                  {[10, 20, 50, 100].map(val => (
                    <a className="dropdown-item" onClick={setPageListItems} data-value={val} key={val}>{val} records</a>
                  ))}
                </div>
              </div>
              <ul className="pagination m-0 ms-auto">
                <li className={`page-item${page === 0 ? ' disabled' : ''}`}>
                  <a className="page-link" href="#" tabIndex="-1" aria-disabled={page === 0}
                    onClick={e => { e.preventDefault(); if (page > 0) setPage(page - 1); }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                      viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                      className="icon icon-1">
                      <path d="M15 6l-6 6l6 6" />
                    </svg>
                    prev
                  </a>
                </li>
                {[...Array(totalPages)].map((_, idx) => (
                  <li key={idx} className={`page-item${page === idx ? ' active' : ''}`}>
                    <a className="page-link" href="#" onClick={e => { e.preventDefault(); setPage(idx); }}>{idx + 1}</a>
                  </li>
                ))}
                <li className={`page-item${page === totalPages - 1 ? ' disabled' : ''}`}>
                  <a className="page-link" href="#" aria-disabled={page === totalPages - 1}
                    onClick={e => { e.preventDefault(); if (page < totalPages - 1) setPage(page + 1); }}>
                    next
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                      viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                      className="icon icon-1">
                      <path d="M9 6l6 6l-6 6" />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.3)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">{editId ? 'Edit Detail' : 'Create Detail'}</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Pilih Event</label>
                    <select
                      className="form-select"
                      name="event"
                      value={form.event}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Pilih Event</option>
                      {events.map((event) => (
                        <option key={event.id} value={event.id}>
                          {event.eventCode} - {event.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Kategori Peserta</label>
                    <select
                      className="form-select"
                      name="audienceCategory"
                      value={form.audienceCategory}
                      onChange={handleChange}
                      required
                      disabled={!form.event}
                    >
                      <option value="">Pilih Kategori Peserta</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>{cat.namaCategory}</option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Kategori Event</label>
                    <select
                      className="form-select"
                      name="categoryEvent"
                      value={form.categoryEvent}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Pilih</option>
                      <option value="Offline">Offline</option>
                      <option value="Online">Online</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Biaya Event</label>
                    <input
                      type="number"
                      className="form-control"
                      name="biayaEvent"
                      value={form.biayaEvent || ""}
                      onChange={handleChange}
                      required
                      min={0}
                    />
                    <div className="form-text mt-1">
                      {form.biayaEvent
                        ? "Rp " + Number(form.biayaEvent).toLocaleString("id-ID")
                        : "-"}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">{editId ? 'Update' : 'Create'}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminAudienceCategoryDetail;